import { render, staticRenderFns } from "./OwnCustomSelect.vue?vue&type=template&id=71b5d794&"
import script from "./OwnCustomSelect.vue?vue&type=script&lang=js&"
export * from "./OwnCustomSelect.vue?vue&type=script&lang=js&"
import style0 from "./OwnCustomSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports